export default "__VITE_ASSET__46bc8af1__"